<template>
    <page title="userManagementTitle" :help="help">
        <template #pageContainer>
            <v-row>
                <!-- <v-col
                    cols="12"
                    md="12">
                    <v-card outlined>
                        <v-row
                            align="center"
                            justify="center">
                            <v-col
                                cols="12"
                                md="12"
                                sm="4">
                                <v-card-text>
                                    <v-icon>remove_circle</v-icon>
                                    {{ $t(`text.removeRoleButtonInfo`) }}
                                </v-card-text>
                            </v-col>
                        </v-row>
                    </v-card>
                </v-col> -->
                <v-col
                    cols="12"
                    md="12" class="py-1">
                    <v-card>
                        <v-data-table
                            v-model="selected"
                            :headers="headers"
                            :items="Entities"
                            class="elevation-1"
                            :page.sync="Pagination.currentPage"
                            :items-per-page="400"
                            :loading="loading"
                            :loading-text="$t('text.userManagementLoading')"
                            group-by="userEmail"
                            :server-items-length="Entities.length"
                            show-select
                            item-key="id"
                            hide-default-footer
							:height="WindowSize.y-380"
                            fixed-header>
                            <template #top>
                                <v-container class="mt-0 pt-0 pb-0 mb-0">
                                    <v-row>
                                        <v-col cols="12" sm="12" lg="2">
                                            <v-btn-toggle
                                                dense
                                                color="primary"
                                                active-class="action-active">
                                                <!-- <v-btn
                                                    color="primary"
                                                    @click="newRole">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.newRoleButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        add
                                                    </v-icon>
                                                </v-btn> -->
                                                <v-btn
                                                    :disabled="!hasSelected"
                                                    color="primary"
                                                    @click="dialogMultipleRoles = true;
                                                        isLastRole = checkRoles(true);">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.deleteRolesButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        delete
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>

                                        <v-col cols="12" sm="6" lg="4">
                                            <v-text-field outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.userName"
                                                :label="$t('text.user')"
                                                @keyup.enter.native="search">
                                            </v-text-field>
                                        </v-col>
                                        <v-col cols="12" sm="6" lg="3">
                                            <v-autocomplete outlined dense
                                                hide-details="auto"
                                                class="mt-0 pt-0"
                                                clearable
                                                v-model="tempQP.organizationId"
                                                :items="organizations"
                                                :label="$t('text.organization')"
                                                :loading="orgLoading"
                                                @keyup.enter.native="search">
                                            </v-autocomplete>
                                        </v-col>

                                        <v-col cols="12" sm="12" lg="3" class="button-col">
                                            <v-btn-toggle
                                                dense
                                                color="secondary"
                                                justify="center"
                                                active-class="action-active">
                                                <v-btn
                                                    color="secondary"
                                                    @click="search">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.searchButton`) }}
                                                    </span>
                                                    <v-icon color="white">
                                                        search
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    color="secondary"
                                                    @click="expandAll">
                                                    <span class="hidden-sm-and-down">
                                                        {{ $t(`text.expandButton`) }}
                                                    </span>
                                                    <v-icon
                                                        color="white"
                                                        v-if="isExpandAll">
                                                        expand_more
                                                    </v-icon>
                                                    <v-icon
                                                        color="white"
                                                        v-else>
                                                        expand_less
                                                    </v-icon>
                                                </v-btn>
                                            </v-btn-toggle>
                                        </v-col>
                                    </v-row>
                                </v-container>
                            </template>
                            <template #[`group.header`]="{ group, headers, toggle, items }">
                                <td :colspan="headers.length">
                                    <v-btn icon v-model="groups"
                                        @click="expand(group, toggle)"
                                        v-if="isExpanded(group, toggle)">
                                        <v-icon>
                                            expand_more
                                        </v-icon>
                                    </v-btn>
                                    <v-btn icon v-model="groups"
                                        @click="expand(group, toggle)"
                                        v-else>
                                        <v-icon>
                                            expand_less
                                        </v-icon>
                                    </v-btn>
                                    {{ items.find(x => x.userEmail === group).userName }} -
                                    {{ group }}
                                </td>
                            </template>
                            <template #[`item.action`]="{ item }">
                                <v-tooltip bottom>
                                    <template #activator="{ on }">
                                        <v-btn icon v-on="on"
                                            :disabled="item.status === userRoleStatus.Deleted"
                                            v-show="HasRoles && IsAdmin"
                                            @click="dialogItem = item;
                                                isLastRole = checkRoles(false); dialog = true;">
                                            <v-icon>
                                                remove_circle
                                            </v-icon>
                                        </v-btn>
                                    </template>
                                    <span>{{ $t(`text.removeRoleButtonInfo`) }}</span>
                                </v-tooltip>
                            </template>
                            <template #[`item.status`]="{ item }">
                                <v-chip :color="getStatusColor(item.status)" dark>
                                    {{ item.status }}
                                </v-chip>
                            </template>
                        </v-data-table>

                        <pagination
                            :currentPage="Pagination.currentPage"
                            :totalPages="Pagination.totalPages"
                            :pageSize="queryParameters.pageSize"
                            @current="current"
                            @pageSizeChanged="pageSizeChanged">
                        </pagination>
                    </v-card>
                </v-col>
            </v-row>

            <v-dialog
                v-model="dialogMultipleRoles"
                width="300">
                <v-card>
                    <v-card-title
                        class="headline grey lighten-2"
                        primary-title>
                        {{ isLastRole ? $t(`text.removeLastRoles`) : $t(`text.removeRole`) }}
                    </v-card-title>
                    <v-card-text v-show="isLastRole">
                        <v-list-item-content>
                            <v-list-item-title
                                v-for="warning in deleteWarnings"
                                v-bind:key="warning">
                                {{ warning }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="dialogMultipleRoles = false;">
                            {{ $t(`text.noButton`) }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="deleteRoles">
                            {{ $t(`text.yesButton`) }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
            <v-dialog
                v-model="dialog"
                width="300">
                <v-card>
                    <v-card-title
                        class="headline grey lighten-2"
                        primary-title>
                        {{ isLastRole ? $t(`text.removeLastRoles`) : $t(`text.removeRole`) }}
                    </v-card-title>
                    <v-card-text v-show="isLastRole">
                        <v-list-item-content>
                            <v-list-item-title
                                v-for="warning in deleteWarnings"
                                v-bind:key="warning">
                                {{ warning }}
                            </v-list-item-title>
                        </v-list-item-content>
                    </v-card-text>
                    <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                            color="primary"
                            text
                            @click="dialogItem = null; dialog = false;">
                            {{ $t(`text.noButton`) }}
                        </v-btn>
                        <v-btn
                            color="primary"
                            text
                            @click="remove(dialogItem)">
                            {{ $t(`text.yesButton`) }}
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-dialog>
        </template>
    </page>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import Page from '../general/Page.vue';
import Pagination from '../general/Pagination.vue';

import userRoleStatus from '../helpers/userRoleStatus';

import userRoleActions from '../store/actions/userRole';
import namespace from '../store/namespace';

class TempUserManagementQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.userName = qp.userName;
			this.organizationId = qp.organizationId;
		}
	}
}

class UserManagementQueryParameter {
	constructor(qp) {
		if (qp !== undefined) {
			this.userName = qp.userName;
			this.organizationId = qp.organizationId;
			this.pageNumber = qp.pageNumber;
			this.pageSize = qp.pageSize;
		} else {
			this.userName = null;
			this.organizationId = null;
			this.pageNumber = 1;
			this.pageSize = 10;
		}
	}

	updateTempData(qp) {
		this.userName = qp.userName;
		this.organizationId = qp.organizationId;
	}
}

export default {
	name: 'UserManagement',
	components: {
		Page,
		Pagination,
	},
	data() {
		return {
			headers: [
				{
					text: this.$i18n.t('text.headerActions'), align: 'left', value: 'action', sortable: false, width: 50,
				},
				{
					text: this.$i18n.t('text.headerRole'), align: 'left', value: 'roleName',
				},
				{
					text: this.$i18n.t('text.headerOrganizationName'), align: 'left', value: 'organizationName', width: '50%',
				},
			],
			loading: true,
			orgLoading: false,
			dialog: false,
			dialogLastRole: false,
			dialogMultipleRoles: false,
			groupEntities: [],
			dialogItem: null,
			isLastRole: false,
			selected: [],
			deleteWarnings: [],
			organizations: [],
			isExpandAll: false,
			queryParameters: new UserManagementQueryParameter(),
			tempQP: new TempUserManagementQueryParameter(),
			help: [{
				icon: 'remove_circle',
				text: this.$t('text.removeRoleButtonInfo'),
			}],
		};
	},
	async mounted() {
		if (localStorage.getItem('userManagerApp')) {
			this.queryParameters = new UserManagementQueryParameter(JSON.parse(localStorage.getItem('userManagerApp')));
			this.tempQP = new TempUserManagementQueryParameter(this.queryParameters);
		} else {
			localStorage.setItem('userManagerApp', JSON.stringify(this.queryParameters));
		}
		await this.loadData();

		await this.getOrganizations();
	},
	computed: {
		...mapGetters(['WindowSize']),
		...mapGetters(namespace.USER, ['IsAdminForOrg', 'HasRoles', 'User', 'IsAdmin']),
		...mapGetters(namespace.ORGANIZATION, ['HasOrganization', 'Organization']),
		...mapGetters(namespace.USERROLE, ['Links', 'Entities', 'Pagination']),
		groups() {
			return this.groupEntities;
		},
		hasSelected() {
			return this.selected
                && this.selected.length > 0
                && !this.selected.some(x => x.status === userRoleStatus.Deleted);
		},
		userRoleStatus() {
			return userRoleStatus;
		},
	},
	watch: {
		async Organization() {
			await this.loadData();
		},
		queryParameters: {
			deep: true,
			handler() {
				localStorage.setItem('userManagerApp', JSON.stringify(this.queryParameters));
			},
		},
	},
	methods: {
		...mapActions(namespace.USERROLE, [
			userRoleActions.GET_USERS_ROLES,
			userRoleActions.DELETE_USER_ROLES,
			userRoleActions.UPDATE_USER_ROLE,
			userRoleActions.FETCH_USERS_ROLES,
			userRoleActions.FETCH_USERS_ROLES_ORGANIZATIONS]),
		getStatusColor(status) {
			switch (status) {
			case userRoleStatus.Deleted: return 'gray';
			case userRoleStatus.Created: return 'blue';
			default: return 'white';
			}
		},
		expand(group, toggle) {
			if (this.groups && this.groups.length > 0) {
				const elem = this.groups.find(element => element.user.userEmail === group);
				elem.toggle = !elem.toggle;
				toggle();
			}
		},
		expandAll(e, isFirstTime = false) {
			if (isFirstTime) {
				this.isExpandAll = false;

				const elems = this.groups.filter(x => x.toggleFn);

				elems.forEach((element) => {
					if (element.toggleFn) {
						const isToggle = element.toggleFn();

						if (isToggle) element.toggleFn();

						element.toggle = false;
					}
				});

				return;
			}

			const elems = this.groups.filter(x => x.toggle === false && x.toggleFn);

			elems.forEach((element) => {
				if (element.toggleFn) {
					element.toggle = element.toggleFn();
				}
			});

			if (elems && elems.length > 0) {
				this.isExpandAll = true;
				return;
			}

			for (let i = 0; i < this.groups.length; i += 1) {
				if (this.groups[i].toggleFn) {
					this.groups[i].toggle = this.groups[i].toggleFn();
				}
			}

			this.isExpandAll = !this.isExpandAll;
		},
		checkRoles(isMultipleDelete) {
			this.deleteWarnings = [];

			if (isMultipleDelete) {
				if (this.selected && this.selected.length > 0) {
					const emails = _.uniq(this.selected.map(({ userEmail }) => userEmail));

					emails.forEach((email) => {
						const userRoles = this.Entities.filter(x => x.userEmail === email);

						const selectUserRoles = this.selected.filter(x => x.userEmail === email);

						if (userRoles.length === selectUserRoles.length) {
							this.deleteWarnings.push(email);
						}
					});
				}
			} else if (this.dialogItem) {
				const userRoles = this.Entities
					.filter(x => x.userEmail === this.dialogItem.userEmail);

				if (userRoles.length === 1) {
					this.deleteWarnings.push(this.dialogItem.userEmail);
				}
			}

			return this.deleteWarnings && this.deleteWarnings.length > 0;
		},
		isExpanded(group, toggle) {
			if (this.groups && this.groups.length > 0) {
				const elem = this.groups.find(element => element.user.userEmail === group);
				elem.toggleFn = toggle;
				return elem ? elem.toggle : false;
			}

			return false;
		},
		async pageSizeChanged(newPageSize) {
			const maxPage = Math.ceil(this.Pagination.totalCount / newPageSize);
			this.queryParameters.pageNumber = maxPage < this.Pagination.currentPage ? maxPage : this.Pagination.currentPage;
			this.queryParameters.pageSize = newPageSize;
			await this.loadData(this.queryParameters);
		},
		async deleteRoles() {
			this.loading = true;
			this.dialogMultipleRoles = false;

			const link = this.Links.find(x => x.rel === 'delete_roles');

			try {
				const deleteRequest = {
					userRoles: this.selected,
					link,
				};

				await this.DELETE_USER_ROLES(deleteRequest);

				await this.loadData(this.queryParameters);

				this.selected = [];
			} finally {
				this.loading = false;
			}
		},
		async update(item) {
			this.loading = true;
			try {
				await this.UPDATE_USER_ROLE(item);

				await this.loadData();
			} finally {
				this.loading = false;
			}
		},
		async remove(item) {
			this.dialog = false;

			const userRole = this.Entities.find(x => x.roleId === item.roleId
                && x.userId === item.userId
                && x.organizationId === item.organizationId);

			this.dialogItem = null;

			const link = userRole.links.find(x => x.rel === 'update');

			if (userRole && link) {
				const itemData = {
					status: 1,
					link,
				};

				await this.update(itemData);
			}
		},
		newRole() {
			this.$router.push({ name: 'newuserrole' });
		},
		async loadData() {
			this.loading = true;
			try {
				this.groupEntities = [];

				await this.GET_USERS_ROLES({
					organizationId: this.Organization,
					queryParameters: this.queryParameters,
				});

				const users = _.uniq(this.Entities.map(entity => entity.userEmail));

				users.forEach((email) => {
					const user = this.Entities.find(x => x.userEmail === email);

					const element = {
						userEmail: email,
						userName: user.userName,
					};

					const userEntity = {
						user: element,
					};

					this.groupEntities.push(userEntity);
				});

				await this.getOrganizations();

				this.expandAll(null, true);
			} finally {
				this.loading = false;
			}
		},
		async search() {
			this.queryParameters.pageNumber = 1;
			this.queryParameters.updateTempData(this.tempQP);
			await this.loadData();
		},
		async getOrganizations() {
			this.orgLoading = true;
			try {
				this.organizations = await this.FETCH_USERS_ROLES_ORGANIZATIONS(
					this.Organization,
				);
			} finally {
				this.orgLoading = false;
			}
		},
		async current(newPage) {
			this.queryParameters.pageNumber = newPage;
			await this.loadData();
		},
	},
};
</script>

<style lang="scss" scoped>
.action-active {
    border-color: rgba(0,0,0,.12) !important;
    color: rgb(255, 255, 255) !important;
    opacity: 0.8 !important;

    &:before {
        opacity: 0 !important;
    }
}

.button-col {
	text-align: end;
}
</style>
